import { render, staticRenderFns } from "./UploadResources.vue?vue&type=template&id=043cafba&scoped=true"
import script from "./UploadResources.vue?vue&type=script&lang=js"
export * from "./UploadResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043cafba",
  null
  
)

export default component.exports